<template>
    <div>
        <app-overlay-loader v-if="preloader" />
        <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form" :data-url="selectedUrl ? `master/product/${inputs.id}` : `master/product`
            ">
            <!-- Center ID -->
            <!-- <div class="form-group row align-items-center">
					<label for="inputs_center_id" class="col-sm-3 mb-0">
						{{ $t("center") }}
					</label>

					<app-input
						id="inputs_center"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_center_id"
						@input="setCenterId"
						:fetch-url="`master/center?`"
						:placeholder="this.$t('center')"
						list-value-field="name"
					/>
				</div> -->

            <!-- Price -->
            
            <!-- <div class="form-group row align-items-center">
                <label for="inputs_academic_calendar_id" class="col-sm-3 mb-0">
                    Semester
                </label>
                <app-input
                    id="inputs_academic_calendar_id"
                    class="col-sm-9"
                    type="advance-search-select"
                    :loaded-per-time="10"
                    v-model="input_academic_calendar_id"
                    @input="setAcademicCalendar"
                    fetch-url="master/academic-calendar"
                    placeholder="Semester"
                    list-value-field="academic_calendar_name"
                    :required="true"
                />
            </div> -->

            <div class="form-group row align-items-center">
                <label for="inputs_description" class="col-sm-3 mb-0">
                    Description
                </label>
                <app-input id="inputs_description" class="col-sm-9" type="text" v-model="inputs.description"
                    :placeholder="$t('description')" :required="true" />
            </div>

            <div class="form-group row align-items-center">
                <label for="inputs_price" class="col-sm-3 mb-0"> Price </label>
                <app-input id="inputs_price" class="col-sm-9" type="number" v-model="inputs.price" placeholder="Price"
                    :required="true" />
            </div>

            <div class="form-group row align-items-center">
                <label for="inputs_teaching_type_id" class="col-sm-3 mb-0">
                    Teaching Type
                </label>
                <app-input id="inputs_teaching_type_id" class="col-sm-9" type="advance-search-select"
                    :loaded-per-time="10" v-model="input_teaching_type_id" @input="setTeachingTypeId"
                    fetch-url="master/teaching-type" placeholder="Teaching Type" list-value-field="teaching_type_desc"
                    :required="true" />
            </div>

            <div class="form-group row align-items-center">
                <label for="inputs_product_category" class="col-sm-3 mb-0">
                    Product Category
                </label>
                <app-input id="inputs_product_category" class="col-sm-9" type="advance-search-select"
                    :loaded-per-time="10" v-model="input_product_category_id" @input="setProductCategoryId"
                    fetch-url="master/product-category?is_hide=false" placeholder="Product Category"
                    list-value-field="category_code" :required="true" />
            </div>

            <!-- <div class="form-group row align-items-center">
					<label for="inputs_product_type_id" class="col-sm-3 mb-0">
						Lesson Plan Type
					</label>
					<app-input
						id="inputs_product_type_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="3"
						v-model="input_product_type_id"
						@input="setProductTypeId"
						fetch-url="master/product-type"
						placeholder="Lesson Plan Type"
						list-value-field="product_type_desc"
						:required="true"
					/>
				</div> -->

            <div class="form-group row align-items-center">
                <label for="inputs_course_type_id" class="col-sm-3 mb-0">
                    Class Type
                </label>
                <app-input id="inputs_course_type_id" class="col-sm-9" type="advance-search-select"
                    :loaded-per-time="10" v-model="input_course_type_id" @input="setCourseTypeId"
                    fetch-url="master/course-type" placeholder="Class Type" list-value-field="course_type_desc"
                    :required="true" />
            </div>

            <div class="form-group row align-items-center">
                <label for="inputs_product_level_id" class="col-sm-3 mb-0">
                    Product Level
                </label>
                <app-input id="inputs_product_level_id" class="col-sm-9" type="advance-search-select"
                    :loaded-per-time="10" v-model="input_product_level_id" @input="setProductLevelId"
                    fetch-url="master/product-level" placeholder="Product Level" list-value-field="product_level_desc"
                    :required="true" />
            </div>

            <div class="form-group row align-items-center">
                <label for="inputs_product_status_id" class="col-sm-3 mb-0">
                    Product Status
                </label>
                <app-input id="inputs_product_status_id" class="col-sm-9" type="advance-search-select"
                    :loaded-per-time="10" v-model="input_product_status_id" @input="setProductStatusId"
                    :fetch-url="`master/product-status`" placeholder="Product Status"
                    list-value-field="product_status_desc" :required="true" />
            </div>
            <div class="form-group row align-items-center">
                <label for="inputs_payment_status_id" class="col-sm-3 mb-0">
                    Payment Status
                </label>
                <app-input id="inputs_payment_status_id" class="col-sm-9" type="advance-search-select"
                    :loaded-per-time="10" v-model="input_payment_status_id" @input="setPaymentStatusId"
                    :fetch-url="`master/payment-status`" placeholder="Payment Status"
                    list-value-field="payment_status_desc" :required="true" />
            </div>

            <!-- <div class="form-group row align-items-center">
					<label for="inputs_name" class="col-sm-3 mb-0">
						{{ $t("name") }}
					</label>
					<app-input
						id="inputs_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.name"
						:placeholder="$t('name')"
						read-only
					/>
				</div> -->

            <div class="form-group row align-items-center">
                <label for="inputs_is_active" class="col-sm-3 mb-0"> &nbsp; </label>
                <div class="col-sm-8">
                    <app-input id="inputs_is_active" :list-value-field="$t('is_active')" type="single-checkbox"
                        v-model="inputs.is_active" />
                </div>
            </div>
            <!-- <div class="form-group row align-items-center">
                    <label for="inputs_email" class="col-sm-3 mb-0">
                        {{ $t('email') }}
                    </label>
                    <app-input id="inputs_email"
                               class="col-sm-9"
                               type="email"
                               v-model="inputs.email"
                               :placeholder="$t('email_type_input')"
                               :required="true"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_phone" class="col-sm-3 mb-0">
                        {{ $t('contact_number') }}
                    </label>
                    <app-input id="inputs_phone"
                               class="col-sm-9"
                               type="tel-input"
                               v-model="phone"
                               :placeholder="$t('type_contact_number')"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_status" class="col-sm-3 mb-0">
                        {{ $t('status') }}
                    </label>
                    <app-input id="inputs_status"
                               class="col-sm-9"
                               type="select"
                               :required="true"
                               v-model="inputs.status"
                               :list="statusLists"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_age" class="col-sm-3 mb-0">
                        {{ $t('age') }}
                    </label>
                    <app-input id="inputs_age"
                               class="col-sm-9"
                               type="number"
                               :max-number="100"
                               v-model="inputs.age"
                               :placeholder="$t('type_age')"/>
                </div>
                <div class="form-group row align-items-center mb-0">
                    <label class="col-sm-3 mb-0">
                        {{ $t('gender') }}
                    </label>
                    <app-input class="col-sm-9"
                               type="radio"
                               v-model="inputs.gender"
                               :list="genderLists"/> -->
            <!-- </div> -->

            <!-- <button type="button" class="btn btn-danger btn-with-shadow" @click="btnAddListPackage">
                <i class="fa fa-plus"></i>
            </button> -->
            <!-- <div v-for="(pkg, index) in packages" :key="index" class="form-group row align-items-center mt-2">
                <label class="col-sm-2 mb-0" style="font-size: 12px;">Package {{ index + 1 }}</label> -->

                <!-- Teaching Type Code -->
                <!-- <div class="col-sm-2">
                    <app-input type="text" v-model="pkg.teachingCode" read-only disabled />
                </div> -->

                <!-- Product Level Code -->
                <!-- <div class="col-sm-2">
                    <app-input type="text" v-model="pkg.productCategoryCode" read-only disabled />
                </div> -->

                <!-- Sequence (manual input) -->
                <!-- <div class="col-sm-2">
                    <app-input type="text" v-model="pkg.sequence" placeholder="001" @input="checkUniqueSequence(pkg)" />
                </div> -->

                <!-- Final Code (gabungan) -->
                <!-- <div class="col-sm-3">
                    <app-input type="text" v-model="pkg.finalCode" read-only disabled />
                </div> -->

                <!-- Button to remove package -->
                <!-- <div class="col-sm-1">
                    <button type="button" class="btn btn-danger btn-sm" @click="removePackage(index)">
                        <i class="fa fa-trash"></i>
                    </button>
                </div> -->
            <!-- </div> -->
            <div class="form-group row align-items-center"></div>
        </form>
    </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";

export default {
	name: "ProductForm",
	mixins: [FormMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					is_active: "",
				};
			},
		},
        onAfterSubmit: {
            type: Function,
            default: (status, res) => console.log('onAfterSubmit = ' + status + ':', res),
        },
	},
    data() {
        return {
            preloader: false,
            input_center_id: this.value
                ? this.value.center
                    ? {
                        id: this.value.center.id || 0,
                        name: this.value.center.name || "",
                        is_active: this.value.center.is_active,
                    }
                    : {
                        id: this.value.center?.id || 0,
                        name: this.value.center?.name || "",
                        is_active: this.value.center?.is_active,
                    }
                : {
                    id: this.value.center.id || 0,
                    name: this.value.center.name || "",
                    is_active: this.value.center.is_active,
                },
            input_teaching_type_id: {},
            // input_academic_calendar_id : {},
            //input_product_type_id:{},
            input_product_category_id: this.value
                ? this.value.product_category
                    ? {
                        id: this.value.product_category.id || 0,
                        name: this.value.product_category.name || "",
                        category_code: this.value.product_category.category_code,
                        is_active: this.value.product_category.is_active,
                    }
                    : {
                        id: this.value.product_category?.id || 0,
                        name: this.value.product_category?.name || "",
                        category_code: this.value.product_category?.category_code,
                        is_active: this.value.product_category?.is_active,
                    }
                : {
                    id: this.value.product_category.id || 0,
                    name: this.value.product_category.name || "",
                    category_code: this.value.product_category.category_code,
                    is_active: this.value.product_category.is_active,
                },
            input_course_type_id: this.value
                ? this.value.course_type
                    ? {
                        id: this.value.course_type.id || 0,
                        course_type_code: this.value.course_type.course_type_code || "",
                        course_type_name: this.value.course_type.course_type_name || "",
                        course_type_desc: this.value.course_type.course_type_desc || "",
                    }
                    : {
                        id: this.value.course_type?.id || 0,
                        course_type_code: this.value.course_type?.course_type_code || "",
                        course_type_name: this.value.course_type?.course_type_name || "",
                        course_type_desc: this.value.course_type?.course_type_desc || "",
                    }
                : {
                    id: this.value.course_type.id || 0,
                    course_type_code: this.value.course_type.course_type_code || "",
                    course_type_name: this.value.course_type.course_type_name || "",
                    course_type_desc: this.value.course_type.course_type_desc || "",
                },
            input_product_level_id: this.value
                ? this.value.product_level
                    ? {
                        product_level_id: this.value.product_level.product_level_id || 0,
                        product_level_code:
                            this.value.product_level.product_level_code || "",
                        product_level_desc:
                            this.value.product_level.product_level_desc || "",
                    }
                    : {
                        product_level_id: this.value.product_level?.product_level_id || 0,
                        product_level_code:
                            this.value.product_level?.product_level_code || "",
                        product_level_desc:
                            this.value.product_level?.product_level_desc || "",
                    }
                : {
                    product_level_id: this.value.product_level.product_level_id || 0,
                    product_level_code:
                        this.value.product_level.product_level_code || "",
                    product_level_desc:
                        this.value.product_level.product_level_desc || "",
                },
            input_product_status_id: this.value
                ? this.value.product_status
                    ? {
                        product_status_id:
                            this.value.product_status.product_status_id || 0,
                        product_status_code:
                            this.value.product_status.product_status_code || "",
                        product_status_desc:
                            this.value.product_status.product_status_desc || "",
                    }
                    : {
                        product_status_id:
                            this.value.product_status?.product_status_id || 0,
                        product_status_code:
                            this.value.product_status?.product_status_code || "",
                        product_status_desc:
                            this.value.product_status?.product_status_desc || "",
                    }
                : {
                    product_status_id: this.value.product_status.product_status_id || 0,
                    product_status_code:
                        this.value.product_status.product_status_code || "",
                    product_status_desc:
                        this.value.product_status.product_status_desc || "",
                },
            input_payment_status_id: this.value
                ? this.value.payment_status
                    ? {
                        payment_status_id:
                            this.value.payment_status.id || 0,
                        payment_status_code:
                            this.value.payment_status.payment_status_code || "",
                        payment_status_desc:
                            this.value.payment_status.payment_status_desc || "",
                    }
                    : {
                        payment_status_id:
                            this.value.payment_status?.id || 0,
                        payment_status_code:
                            this.value.payment_status?.payment_status_code || "",
                        payment_status_desc:
                            this.value.payment_status?.payment_status_desc || "",
                    }
                : {
                    payment_status_id: this.value.payment_status.id || 0,
                    payment_status_code:
                        this.value.payment_status.payment_status_code || "",
                    payment_status_desc:
                        this.value.payment_status.payment_status_desc || "",
                },
            product_types: [
                {
                    id: 1,
                    value: "Course",
                },
                {
                    id: 2,
                    value: "Charge",
                },
                {
                    id: 3,
                    value: "Deduction",
                },
            ],
            inputs: {
                name: "-",
                description: "",
            },

            packages: [],
            input_sequence: '',

            modalId: this.formId,
            modalTitle: this.$t("add"),
        };
    },
	created() {
		if (this.selectedUrl) {
			this.preloader = true;
		}
	},
    methods: {
        submit() {
            if (this.selectedUrl) {
                this.inputs.created_at = this.formattedDate(this.inputs.created_at)
                    ? this.formattedDate(this.inputs.created_at)
                    : this.formattedDate(new Date());
                this.inputs.updated_at = this.formattedDate(new Date());
                this.inputs.center_id = this.input_center_id.id;
                this.inputs.created_by = this.inputs.created_by.id;
                this.inputs.updated_by = this.inputs.updated_by.id;
            }
            this.inputs.packages = this.packages;
            this.save(this.inputs);
        },
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
            this.onAfterSubmit?.(true, response);
		},
		afterError(response) {
			this.$toastr.s(response.data.message);
            this.onAfterSubmit?.(false, response);
		},
        afterSuccessFromGetEditData(response) {
            if (response.data.phone) this.phone = response.data.phone;
            this.inputs = response.data;
            this.inputs.price = this.inputs.price
                ? this.inputs.price.toString().split(".")[0]
                : "";
            this.input_center_id = {
                id: this.inputs.center_id?.id,
                name: this.inputs.center_id?.name,
                is_active: this.inputs.center_id?.is_active,
            };

            let teachingType = {};

            if (response.data.teaching_type?.teaching_type_id) {
                teachingType = {
                    id: response.data.teaching_type?.teaching_type_id,
                    teaching_type_code: response.data.teaching_type?.teaching_type_code,
                    teaching_type_desc: response.data.teaching_type?.teaching_type_desc,
                };
            }

            this.setTeachingTypeId(teachingType);
            
            // this.input_academic_calendar_id = {
            //     id: this.inputs.semester?.id,
            //     academic_calendar_name: this.inputs.semester?.academic_calendar_name
            // };
            this.input_product_category_id = {
                id: this.inputs.teaching_type?.id,
                category_code: this.inputs.product_category?.category_code,
                name: this.inputs.product_category?.name,
            };

            // let productType = {}

            // if (response.data.product_type?.product_type_id) {
            // 	productType = {
            // 		id: response.data.product_type?.product_type_id,
            // 		product_type_code: response.data.product_type?.product_type_code,
            // 		product_type_desc: response.data.product_type?.product_type_desc
            // 	}
            // }

            // this.setProductTypeId(productType);

            this.input_course_type_id = {
                id: this.inputs.course_type?.id,
                course_type_name: this.inputs.course_type?.course_type_name,
                course_type_code: this.inputs.course_type?.course_type_code,
                course_type_desc: this.inputs.course_type?.course_type_desc,
            };
            this.input_product_level_id = {
                product_level_id: this.inputs.product_level?.product_level_id,
                product_level_code: this.inputs.product_level?.product_level_code,
                product_level_desc: this.inputs.product_level?.product_level_desc,
            };
            this.input_product_status_id = {
                product_status_id: this.inputs.product_status?.product_status_id,
                product_status_code: this.inputs.product_status?.product_status_code,
                product_status_desc: this.inputs.product_status?.product_status_desc,
            };
            this.input_payment_status_id = {
                payment_status_id: this.inputs.payment_status?.id,
                payment_status_code: this.inputs.payment_status?.payment_status_code,
                payment_status_desc: this.inputs.payment_status?.payment_status_desc,
            };

            this.packages = response.data.list_packages.map(pkg => ({
                teachingCode: pkg.package_name,
                productCategoryCode: pkg.product_category_id,
                sequence: pkg.number_list,
                finalCode: pkg.finalCode
            }));

            this.preloader = false;
        },
        setCenterId(data) {
            this.inputs.center_id = this.inputs.center_id;
            if (data && data.hasOwnProperty("id")) {
                this.inputs.center_id = data.id;
            }
        },
        setTeachingTypeId(data) {
            if (data && data.hasOwnProperty("id")) {
                this.$set(this.inputs, "teaching_type_id", data.id);
            }

            this.$set(this, "input_teaching_type_id", data);
        },
        // setAcademicCalendar(data) {
        //     if (data && data.hasOwnProperty("id")) {
        //         this.$set(this.inputs, "academic_calendar_id", data.id);
        //     }

        //     this.$set(this, "input_teaching_type_id", data);
        // },
        setProductCategoryId(data) {
            this.inputs.product_category_id = this.inputs.product_category_id;
            if (data && data.hasOwnProperty("id")) {
                this.inputs.product_category_id = data.id;
            }
        },
        // setProductTypeId(data) {
        // 	if (data && data.hasOwnProperty("id")) {
        // 		this.$set(this.inputs, 'product_type_id', data.id);
        // 	}

        // 	this.$set(this, 'input_product_type_id', data);
        // },
        setCourseTypeId(data) {
            this.inputs.course_type_id = this.inputs.course_type_id;
            if (data && data.hasOwnProperty("id")) {
                this.inputs.course_type_id = data.id;
            }
        },
        setProductLevelId(data) {
            this.inputs.product_level_id = this.inputs.product_level_id;
            if (data && data.hasOwnProperty("product_level_id")) {
                this.inputs.product_level_id = data.product_level_id;
            }
        },
        setProductStatusId(data) {
            this.inputs.product_status_id = this.inputs.product_status_id;
            if (data && data.hasOwnProperty("product_status_id")) {
                this.inputs.product_status_id = data.product_status_id;
            }
        },
        setPaymentStatusId(data) {
            this.inputs.payment_status_id = this.inputs.payment_status_id;
            if (data && data.hasOwnProperty("payment_status_id")) {
                this.inputs.payment_status_id = data.id;
            }
        },
        btnAddListPackage() {
            if (!this.input_teaching_type_id || !this.input_product_category_id) {
                alert('Pilih Teaching Type dan Product Category dulu!');
                return;
            }

            const teachingCode = this.input_teaching_type_id?.teaching_type_code || '';
            const productCategoryCode = this.input_product_category_id?.category_code || '';

            this.packages.push({
                teachingCode: teachingCode,
                productCategoryCode: productCategoryCode,
                sequence: this.input_sequence, 
                finalCode: ''
            });

            this.updateFinalCode(this.packages[this.packages.length - 1]); 
            this.input_sequence = ''; 
        },
        updateFinalCode(pkg) {
            pkg.finalCode = `${pkg.teachingCode}${pkg.productCategoryCode}${pkg.sequence}`
        },
        removePackage(index) {
            this.packages.splice(index, 1); 
        },
        checkUniqueSequence(pkg) {
            const sequenceValues = this.packages.map(p => p.sequence);
            if (sequenceValues.filter(seq => seq === pkg.sequence).length > 1) {
                alert('number list already exists, please enter a different one!');
                pkg.sequence = ''; 
            }
            this.updateFinalCode(pkg); 
        },
        formattedDate(payloadDate) {
            const originalDate = payloadDate;
            const date = new Date(originalDate);

            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0"); 
            const day = date.getDate().toString().padStart(2, "0");

            const hour = date.getHours().toString().padStart(2, "0");
            const minute = date.getMinutes().toString().padStart(2, "0");
            const second = date.getSeconds().toString().padStart(2, "0");

            const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;

            return formattedDate;
        },
        handleScroll(event) {
            const dropdown = event.target;

            let loadMoreBtn = dropdown.querySelector(
                ".btn.btn-light.btn-sm.btn-block"
            );
            if (!loadMoreBtn) {
                loadMoreBtn = document.querySelector(".btn.btn-light.btn-sm.btn-block");
            }

            if (!loadMoreBtn || this.isLoading) return;

            const scrollBottom =
                dropdown.scrollTop + dropdown.clientHeight >=
                dropdown.scrollHeight - 10;

            if (scrollBottom) {
                this.isLoading = true;
                loadMoreBtn.click();

                setTimeout(() => {
                    this.isLoading = false;
                }, 500); 
            }
        },
    },
    watch: {
        inputs(newVal) {
            this.$emit('input', newVal);
        },
        input_teaching_type_id(newVal) {
            if (newVal && newVal.teaching_type_code) {
                this.packages.forEach(pkg => {
                    pkg.teachingCode = newVal.teaching_type_code;
                    // update ulang finalCode
                    pkg.finalCode = `${pkg.teachingCode}${pkg.productCategoryCode}${pkg.sequence}`;
                });
            }
        },
        input_product_category_id(newVal) {
            if (newVal && newVal.category_code) {
                this.packages.forEach(pkg => {
                    pkg.productCategoryCode = newVal.category_code;
                    pkg.finalCode = `${pkg.teachingCode}${pkg.productCategoryCode}${pkg.sequence}`;
                });
            }
        }
    },
}
</script>